import { useLocation } from 'react-router-dom'
import { tryFallbackCookieAuthForRoute } from './cookieAuthFallbacks'

export function useFallbackCookieAuthForRoute(isAuthenticated: boolean) {
  const { pathname } = useLocation()

  return isAuthenticated || tryFallbackCookieAuthForRoute(pathname)
}
